module.exports = __webpack_public_path__ + "img/10.9bc22b54.png";